import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
	Unique,
} from 'typeorm';
import { AutomationExecutionEntity } from './automation-execution.entity';
import { AutomationFlowEntity } from './automation-flow.entity';
import { AutomationStepEntity } from './automation-step.entity';
import { BaseEntity } from './base.entity';

@Entity('_automation_version')
@Unique(['flowId', 'versionNumber'])
@Index(['flowId'])
export class AutomationVersionEntity extends BaseEntity {
	@Column({
		name: '_fk__automation_flow__id',
		type: 'int',
		unsigned: true,
	})
	public flowId!: number;

	@ManyToOne(() => AutomationFlowEntity, (flow) => flow.versions, {
		onDelete: 'CASCADE',
	})
	@JoinColumn({ name: '_fk__automation_flow__id' })
	public flow!: AutomationFlowEntity;

	@Column({
		name: '_version_number',
		type: 'int',
		nullable: true,
	})
	public versionNumber?: number;

	@Column({
		name: '_name',
		type: 'varchar',
		length: 255,
		nullable: true,
	})
	public name?: string;

	@Column({
		name: '_description',
		type: 'text',
		nullable: true,
	})
	public description?: string;

	@OneToMany(() => AutomationStepEntity, (step) => step.version)
	public steps!: AutomationStepEntity[];

	@OneToMany(() => AutomationExecutionEntity, (execution) => execution.version)
	public executions!: AutomationExecutionEntity[];

	// Helper to get display name
	public get displayName(): string {
		if (this.versionNumber == null) {
			return 'Draft';
		}
		return this.name || `Version ${this.versionNumber}`;
	}
}
